export default __webpack_public_path__ + "static/media/qr_chplay_okara_mz.04a0e646.svg";